import { render, staticRenderFns } from "./mall-goods.vue?vue&type=template&id=b59821ce&scoped=true&"
import script from "./mall-goods.vue?vue&type=script&lang=js&"
export * from "./mall-goods.vue?vue&type=script&lang=js&"
import style0 from "./mall-goods.vue?vue&type=style&index=0&id=b59821ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59821ce",
  null
  
)

export default component.exports